module.exports = __webpack_public_path__ + "static/media/down-arrow-table.7c1e0614.svg";